import component from '@123/druid/dist/Framework/Decorators/Component';
import {inject} from '@123/druid/dist/Framework/Decorators/Inject';
import onClick from '@123/druid/dist/Framework/Decorators/OnClick';
import View from '@123/druid/dist/Framework/View/View';
import CookieTracking from '@Module/Tracking/CookieTracking';

@component
export default class CookiePopupView extends View {
    constructor(@inject(CookieTracking) protected cookieTracking: CookieTracking) {
        super();
    }

    @onClick('accept-cookies')
    protected async accepted(): Promise<void> {
        await this.cookieTracking.updateCookiePreference(true);
        this.hide();
    }

    @onClick('refuse-cookies')
    protected async rejected(): Promise<void> {
        await this.cookieTracking.updateCookiePreference(false);
        this.hide();
    }
}
